var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTailedArrow2 = function SvgTailedArrow2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none",
    className: "hidden md:block",
    viewBox: "0 0 32 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_540)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 15.5,
    fill: "#F7F7F7",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22 16.3a.5.5 0 01-.5.5h-9.793l3.647 3.646a.5.5 0 01-.708.708l-4.5-4.5a.501.501 0 010-.708l4.5-4.5a.5.5 0 11.708.708L11.707 15.8H21.5a.5.5 0 01.5.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_540"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z",
    transform: "translate(0 .5)"
  })))));
};
export default SvgTailedArrow2;